module.exports = __webpack_public_path__ + "img/0x190b589cf9Fb8DDEabBFeae36a813FFb2A702454.5971d5a4.png";